import React, { createContext, useContext, useState } from "react";
import { useMutation, useLazyQuery } from "@apollo/client";
import {
    GET_ELIGIBLE_DONORS,
    GET_NON_ELIGIBLE_DONORS,
    GET_DONORS_THAT_VISTED_MORE_THAN_THREE_TIMES,
    GET_DONORS_WTIH_SPECIFIC_ABO_TYPE,
    GET_DONOR_WTIH_SPECIFIC_GENDER,
    FILTER_DONORS_BY_DATE,
    GET_DONORS_GENDER_STATISTICS,
    GET_DONORS_AGE_STATISTICS,
    GET_DONORS_GENDER_AGE_STATISTICS,
    GET_BLOOD_GROUP_STATISTICS,
    GET_DONOR_BLOOD_GROUP_STATISTICS,
    GET_DONOR_COUNT_PER_COLLECTION_SITE,
    GET_ALL_CAMPAIGNS,
    GET_ALL_COLLECTION_SITES
} from "../../graphql/mutation/donor.mutation";

const DonorContext = createContext();

export const DonorProvider = ({ children }) => {
    const [eligibleDonors, setEligibleDonors] = useState([]);
    const [nonEligibleDonors, setNonEligibleDonors] = useState([]);
    const [specificABODonors, setSpecificABODonors] = useState([]);
    const [
        donorsThatVistMoreThanThreeTimes,
        setDonorsThatVisitMoreThanThreeTimes,
    ] = useState([]);
    const [filteredDonorsByDate, setFilteredDonorsByDate] = useState([]);
    const [totalEligibleDonors, setTotalEligibleDonors] = useState(0);
    const [totalNonEligibleDonors, setNonTotalEligibleDonors] = useState(0);
    const [
        totalDonorsThatVistMoreThanThreeTimes,
        setTotalDonorsThatVisitMoreThanThreeTimes,
    ] = useState(0);
    const [totalFilteredDonorsByDate, setTotalFilteredDonorsByDate] = useState(0);
    const [totalTypeA, setTotalTypeA] = useState(0);
    const [totalTypeB, setTotalTypeB] = useState(0);
    const [totalTypeAB, setTotalTypeAB] = useState(0);
    const [totalTypeO, setTotalTypeO] = useState(0);
    const [maleDonors, setMaleDonors] = useState([]);
    const [femaleDonors, setFemaleDonors] = useState([]);
    const [totalFemaleDonors, setTotalFemaleDonors] = useState(0);
    const [totalMaleDonors, setTotalMaleDonors] = useState(0);
    const [getDonorsWithSpecificGender] = useMutation(
        GET_DONOR_WTIH_SPECIFIC_GENDER
    );
    const [getEligibleDonors] = useMutation(GET_ELIGIBLE_DONORS);
    const [getNonEligibleDonors] = useMutation(GET_NON_ELIGIBLE_DONORS);
    const [getDonorsGenderStatisticsMutation] = useMutation(GET_DONORS_GENDER_STATISTICS);
    const [getDonorsAgeStatisticsMutation] = useMutation(GET_DONORS_AGE_STATISTICS);
    const [getDonorsThatVisitMoreThanThreeTimes] = useMutation(
        GET_DONORS_THAT_VISTED_MORE_THAN_THREE_TIMES
    );
    const [genderAgeStatistics, setGenderAgeStatistics] = useState(null);
    const [getDonorsGenderAgeStatisticsMutation] = useMutation(GET_DONORS_GENDER_AGE_STATISTICS);
    const [getBloodGroupStatisticsMutation] = useMutation(GET_BLOOD_GROUP_STATISTICS);
    const [getSpecificABODonors] = useMutation(GET_DONORS_WTIH_SPECIFIC_ABO_TYPE);
    const [getDonorsByDate] = useMutation(FILTER_DONORS_BY_DATE)
    const [getDonorBloodGroupGender] = useMutation(GET_DONOR_BLOOD_GROUP_STATISTICS);
    const [getDonorCountPerCollectionSiteQuery] = useLazyQuery(GET_DONOR_COUNT_PER_COLLECTION_SITE, {
        fetchPolicy: "network-only"
    });
    const [getAllCampaignsQuery] = useLazyQuery(GET_ALL_CAMPAIGNS, {
        fetchPolicy: "network-only"
    });
    const [getAllCollectionSitesQuery] = useLazyQuery(GET_ALL_COLLECTION_SITES, {
        fetchPolicy: "network-only"
    });
    const [genderStatistics, setGenderStatistics] = useState(null);
    const [donorCountPerCollectionSite, setDonorCountPerCollectionSite] = useState(null);
    const [campaigns, setCampaigns] = useState([]);
    const [collectionSites, setCollectionSites] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [ageStatistics, setAgeStatistics] = useState(null);
    const [bloodGroupStatistics, setBloodGroupStatistics] = useState(null);
    const [bloodGroupGenderStatistics, setBloodGroupGenderStatistics] = useState(null);
    const fetchDonorsByType = async (type = "eligible", skip = 0, limit = 10, filter = null) => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            let response;
            if (type === "eligible") {
                response = await getEligibleDonors({
                    variables: { data: { skip, limit }, filter },
                });
                setEligibleDonors(response.data.getEligibleDonors.donors);
                setTotalEligibleDonors(response.data.getEligibleDonors.total);
            } else if (type === "non-eligible") {
                response = await getNonEligibleDonors({
                    variables: { data: { skip, limit }, filter },
                });
                setNonEligibleDonors(response.data.getNonEligibleDonors.donors);
                setNonTotalEligibleDonors(response.data.getNonEligibleDonors.total);
            } else if (type === "visited-more-than-three") {
                response = await getDonorsThatVisitMoreThanThreeTimes({
                    variables: { data: { skip, limit }, filter },
                });
                setDonorsThatVisitMoreThanThreeTimes(
                    response.data.getDonorsWithMoreThanOrEq3Donations.donors
                );
                setTotalDonorsThatVisitMoreThanThreeTimes(
                    response.data.getDonorsWithMoreThanOrEq3Donations.total
                );
            }
            setSuccess(true);
        } catch (error) {
            setError(error.message || "Failed to fetch donors");
        } finally {
            setLoading(false);
        }
    };

    const fetchABODonors = async (type, skip = 0, limit = 10) => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await getSpecificABODonors({ variables: { type, data: { skip, limit } } });
            const fetchedDonors = response.data.getDonorsWithSpecificABOType;

            setSpecificABODonors(fetchedDonors.donors);

            if (type === "A") setTotalTypeA(fetchedDonors.total);
            if (type === "B") setTotalTypeB(fetchedDonors.total);
            if (type === "AB") setTotalTypeAB(fetchedDonors.total);
            if (type === "O") setTotalTypeO(fetchedDonors.total);

            setSuccess(true);
        } catch (error) {
            setError(error.message || "Failed to fetch donors");
        } finally {
            setLoading(false);
        }
    };


    const fetchDonorsByGender = async (gender) => {
        try {
            const { data } = await getDonorsWithSpecificGender({
                variables: { gender },
            });

            if (gender === "MALE") {
                setMaleDonors(data.getDonorsWithSpecificGender);
                setTotalMaleDonors(data.getDonorsWithSpecificGender.length);
            } else {
                setFemaleDonors(data.getDonorsWithSpecificGender);
                setTotalFemaleDonors(data.getDonorsWithSpecificGender.length);
            }
        } catch (error) {
            console.error(`Error fetching ${gender} donors:`, error);
            return [];
        }
    };

    const fetchFilterDonorsByDate = async (startDonationDate, endDonationDate) => {
        try {
            const { data } = await getDonorsByDate({
                variables: { startDonationDate, endDonationDate, skip: 0, limit: 100, donationType: "شرفي", subDonationType: "دم كامل", locale: "ar" },
            });
            console.log(data)
            setFilteredDonorsByDate(data.getDonorsByDate);
            setTotalFilteredDonorsByDate(data.getDonorsByDate.length);
        } catch (error) {
            console.error("Error filtering donors by date:", error);
        }
    };

    const fetchDonorsGenderStatistics = async (filter = null) => {
        // Prevent multiple simultaneous calls
        if (loading) return;

        setLoading(true);
        setError(null);

        try {
            const { data } = await getDonorsGenderStatisticsMutation({
                variables: { filter }
            });

            if (data?.getDonorGenderStatistics) {
                const stats = data.getDonorGenderStatistics;

                setGenderStatistics(stats);
                setTotalMaleDonors(stats.maleCount);
                setTotalFemaleDonors(stats.femaleCount);
                setSuccess(true);

                return stats;
            }
        } catch (error) {
            setError(error.message || "Failed to fetch gender statistics");
            console.error("Error fetching gender statistics:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchDonorsAgeStatistics = async (filter = null) => {
        if (loading) return;

        setLoading(true);
        setError(null);

        try {
            const { data } = await getDonorsAgeStatisticsMutation({
                variables: { filter }
            });

            if (data?.getDonorAgeStatistics) {
                const stats = data.getDonorAgeStatistics;
                setAgeStatistics(stats);
                setSuccess(true);
                return stats;
            }
        } catch (error) {
            setError(error.message || "Failed to fetch age statistics");
            console.error("Error fetching age statistics:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchDonorsGenderAgeStatistics = async (filter = null) => {
        if (loading) return;

        setLoading(true);
        setError(null);

        try {
            const { data } = await getDonorsGenderAgeStatisticsMutation({
                variables: { filter }
            });

            if (data?.getDonorGenderAgeStatistics) {
                const stats = data.getDonorGenderAgeStatistics;
                setGenderAgeStatistics(stats);
                setSuccess(true);
                return stats;
            }
        } catch (error) {
            setError(error.message || "Failed to fetch gender-age statistics");
            console.error("Error fetching gender-age statistics:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchBloodGroupStatistics = async (filter = null) => {
        if (loading) return;

        setLoading(true);
        setError(null);

        try {
            const { data } = await getBloodGroupStatisticsMutation({
                variables: { filter }
            });

            if (data?.getBloodGroupStatistics) {
                const stats = data.getBloodGroupStatistics;
                setBloodGroupStatistics(stats);
                setSuccess(true);
                return stats;
            }
        } catch (error) {
            setError(error.message || "Failed to fetch blood group statistics");
            console.error("Error fetching blood group statistics:", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchDonorGenderBloodGroupStatistics = async (filter = null) => {
        if (loading) return;

        setLoading(true);
        setError(null);

        try {
            const { data } = await getDonorBloodGroupGender({
                variables: { filter }
            });

            if (data?.getDonorGenderBloodGroupStatistics) {
                const stats = data.getDonorGenderBloodGroupStatistics;
                setBloodGroupGenderStatistics(stats);
                setSuccess(true);
                return stats;
            }
        } catch (error) {
            setError(error.message || "Failed to fetch blood group statistics");
            console.error("Error fetching blood group statistics:", error);
        } finally {
            setLoading(false);
        }
    }

    const fetchDonorCountPerCollectionSite = async (filter = {}) => {
        if (loading) return;

        setLoading(true);
        setError(null);

        try {
            const { data } = await getDonorCountPerCollectionSiteQuery({
                variables: { filter }
            });

            if (data?.getDonorCountPerCollectionSite) {
                const stats = data.getDonorCountPerCollectionSite;
                setDonorCountPerCollectionSite(stats);
                setSuccess(true);
                return stats;
            }
        } catch (error) {
            setError(error.message || "Failed to fetch donor count per collection site");
            console.error("Error fetching donor count per collection site:", error);
        } finally {
            setLoading(false);
        }
    }

    const fetchAllCampaigns = async (locale = "en") => {
        console.log("fetchAllCampaigns called with locale:", locale);
        try {
            const { data } = await getAllCampaignsQuery({
                variables: { locale }
            });
            console.log("getAllCampaigns response:", data);

            if (data?.getAllCampaigns) {
                setCampaigns(data.getAllCampaigns);
                return data.getAllCampaigns;
            }
        } catch (error) {
            console.error("Error fetching campaigns:", error);
        }
    }

    const fetchAllCollectionSites = async () => {
        try {
            const { data } = await getAllCollectionSitesQuery();

            if (data?.getCollectionSites) {
                setCollectionSites(data.getCollectionSites);
                return data.getCollectionSites;
            }
        } catch (error) {
            console.error("Error fetching collection sites:", error);
        }
    }

    return (
        <DonorContext.Provider
            value={{
                eligibleDonors,
                specificABODonors,
                totalEligibleDonors,
                loading,
                error,
                success,
                totalFemaleDonors,
                totalMaleDonors,
                fetchDonorsByGender,
                fetchABODonors,
                fetchDonorsByType,
                totalNonEligibleDonors,
                nonEligibleDonors,
                totalDonorsThatVistMoreThanThreeTimes,
                donorsThatVistMoreThanThreeTimes,
                maleDonors,
                femaleDonors,
                totalTypeA,
                totalTypeB,
                totalTypeAB,
                totalTypeO,
                filteredDonorsByDate,
                totalFilteredDonorsByDate,
                fetchFilterDonorsByDate,
                fetchDonorsGenderStatistics,
                ageStatistics,
                fetchDonorsAgeStatistics,
                genderAgeStatistics, // ✅ Make sure this is here
                fetchDonorsGenderAgeStatistics, // ✅ And this too
                genderStatistics,
                fetchBloodGroupStatistics,
                fetchDonorGenderBloodGroupStatistics,
                bloodGroupGenderStatistics,
                bloodGroupStatistics,
                donorCountPerCollectionSite,
                fetchDonorCountPerCollectionSite,
                campaigns,
                fetchAllCampaigns,
                collectionSites,
                fetchAllCollectionSites
            }}
        >
            {children}
        </DonorContext.Provider>
    );
};

export const useDonor = () => useContext(DonorContext);

export default DonorProvider;
